import { AdminShell } from "@project/admin/components/admin-shell";
import { ApiResourceTable } from "@project/admin/components/api-resource-table";
import type { Field } from "@project/admin/components/resource-table";
import { festivalService } from "@project/services/admin/festival.service";
import {
  FESTIVAL_TYPE_OPTIONS,
  type Festival,
  type FestivalType,
} from "@project/types/festival";

const fields: Field[] = [
  {
    name: "name",
    label: "Festival Name",
    required: true,
    showInTable: true,
    placeholder: "Mahavir Jayanti",
  },
  {
    name: "type",
    label: "Type",
    type: "select",
    required: true,
    showInTable: true,
    placeholder: "Select type...",
    options: [...FESTIVAL_TYPE_OPTIONS],
  },
  {
    name: "description",
    label: "Description",
    type: "textarea",
    showInTable: true,
    placeholder: "Birth anniversary of Lord Mahavir",
  },
];

function toFestivalType(value: unknown): FestivalType {
  const raw = String(value ?? "")
    .trim()
    .toLowerCase();
  if (raw === "hindu" || raw === "jain") {
    return raw;
  }
  throw new Error("Select a valid type.");
}

function toFestivalPayload(payload: Record<string, unknown>) {
  return {
    name: String(payload.name),
    type: toFestivalType(payload.type),
    description: payload.description ? String(payload.description) : undefined,
  };
}

export default function Page() {
  return (
    <AdminShell
      title="Festivals"
      subtitle="Manage festival master data for Jain Panchang entries"
    >
      <ApiResourceTable<Festival>
        title="Festival"
        labelField="name"
        fields={fields}
        searchFields={["name", "description"]}
        list={query => festivalService.listFestivalsPage(query)}
        create={payload =>
          festivalService.createFestival(toFestivalPayload(payload))
        }
        update={(id, payload) =>
          festivalService.updateFestival(id, toFestivalPayload(payload))
        }
        remove={id => festivalService.deleteFestival(id)}
      />
    </AdminShell>
  );
}
